import { JSX, useEffect, useLayoutEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "src/context/SessionContext";
import Loading from "../Loading/Loading";
import { Paths } from "src/constants/paths";

type PublicRouteProps = {
  children: JSX.Element;
};

const PublicRoute = ({ children }: PublicRouteProps) => {
  const { session, loading } = useSession();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    const justSignedUp = sessionStorage.getItem("justSignedUp") === "true";
    if (session && justSignedUp) {
      sessionStorage.removeItem("justSignedUp");
    }
  }, [session]);

  if (session) {
    if (loading) {
      return <Loading />;
    }

    return <Navigate to={`${Paths.AUTH_QUEUE}`} replace />;
  }

  return children;
};

export default PublicRoute;
